module.exports = __webpack_public_path__ + "img/detail5.7ddea520.png";